import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { resetPassword } from '../../containers/ResetPass/actions';
import { selectUser } from '../../containers/App/selectors';
import V2PublicAuthShell from '../components/V2PublicAuthShell';

const V2ResetPass: React.FC = () => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState('');

  if (user) {
    return <Navigate to="/statistics" replace />;
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setError('Введите корректный email.');
      return;
    }

    setError('');
    dispatch(resetPassword(email.trim()));
  };

  return (
    <V2PublicAuthShell
      title={t('password_recovery')}
      subtitle={t('enter_your_email_address_and_we_will_send_you_a_link_to_restore_your_password')}
      footer={
        <div className="signup-row">
          <span>Вспомнили пароль?</span>
          <Link to="/">
            Войти <span aria-hidden="true">↗</span>
          </Link>
        </div>
      }
    >
      <form noValidate onSubmit={handleSubmit}>
        <label htmlFor="reset-email">Email</label>
        <input
          id="reset-email"
          type="email"
          placeholder="you@example.com"
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />

        {error ? (
          <span className="field-error" aria-live="polite">
            {error}
          </span>
        ) : null}

        <button className="login-submit" type="submit">
          {t('reset')} <span aria-hidden="true">↗</span>
        </button>
      </form>
    </V2PublicAuthShell>
  );
};

export default V2ResetPass;
